import React from 'react';
import styled from 'styled-components';

interface Props {
    colSpan: number;
    height: number;
}

const HBNewTableSpacer = ({ colSpan, height }: Props) => {
    return (
        <StyledTr>
            <StyledTd colSpan={colSpan}>
                <Spacer height={height} />
            </StyledTd>
        </StyledTr>
    );
};

export default HBNewTableSpacer;

// --- Styles ---

const StyledTr = styled.tr``;

const StyledTd = styled.td``;

const Spacer = styled.div<{ height: number }>`
    height: ${props => props.height}px;
`;
